import {
  API_FUNCTIONS,
  SUPPORTED_PRODUCT_TYPES,
  getLevelFromStep,
} from "./mappings";
import {
  getCurrentProductType,
  getStepKeysForProduct,
  getMaxLevelForProduct,
} from "./helpers";
import { store, persistor, resetProductsState } from "@services/redux/store";
import { resetStep } from "@services/redux/slices/stepSlice";

// Post product to API (new route format)
export const postProduct = async (productId, productData, level) => {
  const productType = getCurrentProductType();
  const apiFunction = API_FUNCTIONS[productType];

  if (!apiFunction) {
    throw new Error(`Unsupported product type: ${productType}`);
  }

  try {
    return await apiFunction(productId, productData, level);
  } catch (error) {
    console.error("Error posting product (v2):", error);
    throw error;
  }
};

// Helpers

// Submit product steps (new route logic)
const submitProductSteps = async (
  productData,
  targetLevel,
  dispatch = null,
  shouldClearState = false
) => {
  const productType = getCurrentProductType();
  if (!SUPPORTED_PRODUCT_TYPES.includes(productType)) {
    throw new Error(`Unsupported product type: ${productType}`);
  }

  const stepKeys = getStepKeysForProduct(productType);
  const results = {};
  let currentProductId = null;

  for (let level = 1; level <= targetLevel; level++) {
    const stepKey = stepKeys[level - 1];
    if (!productData[stepKey]) {
      console.warn(`Step data missing for ${stepKey} at level ${level}`);
      continue;
    }

    const stepPayload = { ...productData[stepKey] };
    const stepResult = await postProduct(currentProductId, stepPayload, level);
    if (!stepResult) throw new Error(`${stepKey} submission failed`);

    results[`${stepKey}Result`] = stepResult;

    // Step 1 returns product_id
    if (level === 1) {
      currentProductId = stepResult.product_id;
      if (!currentProductId)
        throw new Error("Step 1 failed to return a product_id");
    }
  }

  if (shouldClearState) {
    store.dispatch(resetProductsState());
    store.dispatch(resetStep());
    localStorage.removeItem("productTypeInfo");
    localStorage.removeItem("product");
  }

  return results;
};

export const saveCurrentProduct = async (dispatch, productData, step) => {
  const productType = getCurrentProductType();
  const level = getLevelFromStep(productType, step);
  if (!level) {
    console.warn(
      `No API level mapping found for ${productType} at UI step ${step}`
    );
    return;
  }

  const results = await submitProductSteps(productData, level, dispatch, true);
  const stepKeys = getStepKeysForProduct(productType);
  return results[`${stepKeys[level - 1]}Result`];
};

export const finalSubmitProduct = async () => {
  const productType = getCurrentProductType();
  const maxLevel = getMaxLevelForProduct(productType);
  if (!maxLevel) {
    throw new Error(
      `No step configuration found for product type: ${productType}`
    );
  }

  const productData = store.getState()[productType.toLowerCase()];

  return await submitProductSteps(productData, maxLevel, null, true);
};
